import { produce } from 'immer';

import { RemoveInternalMarketerProductAccess } from '../../../actions/marketer/internal/removeInternalMarketerProductAccess';
import { MarketerState } from '../../../typings/marketers';

export function removeInternalMarketerProductAccess(
    state: MarketerState,
    action: RemoveInternalMarketerProductAccess
): MarketerState {
    return produce(state, draft => {
        const product = draft.marketer.ownProducts.find(item => item.id === action.productId);

        if (product) {
            product.isRemoving = true;
        }
    });
}
